import React, { useState } from "react";
import { Typography, Form, message } from "antd";
import {
  createImpact,
  getImpactsByProject,
} from "../Application/Projects.business";
import { CustomFormItem, ButtonEgreen } from "../../Utils/UI/Text"; 

const ImpactForm = ({ projectId, onSuccess }) => {
  const [form] = Form.useForm();
  const [values, setValues] = useState({
    title: "",
    subtitle: "",
  });

  const resetForm = () => {
    setValues({
      title: "",
      subtitle: "",
    });
    form.resetFields();
  };

  const handleSubmit = async () => {
    const { title, subtitle } = form.getFieldsValue();

    try {
      await createImpact(projectId, { title, subtitle });
      message.success("Impacto guardado exitosamente");
      getImpactsByProject(projectId);
      resetForm();

      if (onSuccess) {
        onSuccess(); 
      }
    } catch (error) {
      console.error("Error:", error);
      message.error("Error al guardar el impacto");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <Typography.Title level={3}>Crear Nuevo Impacto</Typography.Title>
      <Form
        layout="vertical"
        onFinish={handleSubmit}
        form={form}
        initialValues={values}
        onValuesChange={(_, allValues) => {
          setValues(allValues);
        }}
      >
        <CustomFormItem
          label="Título"
          name="title"
          placeholder="Ingrese el título"
          maxLength={25}
          rules={[{ required: true, message: "Título no válido" }]}
        />
        <CustomFormItem
          label="Subtítulo"
          name="subtitle"
          placeholder="Ingrese el subtítulo"
          maxLength={25}
          rules={[{ required: true, message: "Subtítulo no válido" }]}
        />
        <div style={{ marginTop: "20px" }}>
          <ButtonEgreen 
            text="Guardar Impacto" 
            onClick={handleSubmit} 
            style={{ backgroundColor: "#52c41a", color: "white" }}
          />
        </div>
      </Form>
    </div>
  );
};

export default ImpactForm;